var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fullscreen',[(!_vm.showFirstLoginForm)?_c('LoginForm',{on:{"first-login":function($event){_vm.showFirstLoginForm = true}}}):_c('FirstLoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }